export const articles = [
  {
    id: "xuanxiu-2011-reunion",
    title: "那届选秀的第六名，十五年后才被重新听见",
    excerpt:
      "当年的票数排名早已模糊，可他在淘汰夜唱的那首歌，最近突然被翻了出来。评论区第一句话是：原来他还在唱。",
    category: "xuanxiu",
    categoryName: "选秀记忆",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20empty%20stage%20under%20a%20single%20warm%20spotlight%20with%20a%20retro%20microphone%20stand%2C%20film%20grain%2C%20deep%20brick%20red%20and%20aged%20gold%20tones%2C%20dust%20particles%20in%20the%20light%2C%20artistic%20editorial%20still%2C%20no%20people%2C%20warm%20nostalgic%20mood&width=800&height=600&seq=arch-xuanxiu-2011&orientation=landscape",
    date: "2026-08-18",
    year: "2011",
    readTime: 8,
    featured: true,
    tags: ["选秀考古", "旧料翻出", "被遗忘的名字"],
    author: "档案室 · 老周",
    content: [
      {
        type: "p",
        text: "那年夏天，电视里一共站着三十多个人。前五名后来都发了专辑、上了综艺、开了巡演，只有第六名，在淘汰夜说完谢谢就走了，像是从名单上被轻轻划掉。",
      },
      {
        type: "h2",
        text: "一、淘汰夜的那首歌，其实没播完",
      },
      {
        type: "p",
        text: "很多年后重看那期节目，会发现一个细节：他唱完最后一句时，伴奏其实还有八秒。镜头在这八秒里切给了观众席、切给了评委、切给了已经准备好的下一位选手，唯独没有留给他。",
      },
      {
        type: "quote",
        text: "后来他接受采访时说，那天最遗憾的不是名次，是那八秒没被别人听见。",
      },
      {
        type: "h2",
        text: "二、离开之后，他去了哪",
      },
      {
        type: "p",
        text: "公开的资料里，他回了一趟老家，在一间很小的琴行教课。有人拍到过他弹琴的侧脸，照片糊得看不清，但能看出手型没变。那几年他偶尔写歌，只是没有再登上过任何stage。",
      },
      {
        type: "list",
        items: [
          "2012 年，回到内陆小城，继续做音乐老师。",
          "2015 年，在一场商场活动里唱了两首自己的歌，台下不到二十人。",
          "2019 年，把当年那首没唱完的demo重新编曲，发在了一个没人关注的账号上。",
          "2026 年，那段淘汰夜的片段被剪出来，播放量一夜之间过了千万。",
        ],
      },
      {
        type: "h2",
        text: "三、为什么是现在被翻出来",
      },
      {
        type: "p",
        text: "选秀考古有意思的地方就在这里：真正被记住的，往往不是当年的冠军，而是某个没走到最后、却留下了一个画面的人。时间会把排名冲淡，把歌声留下。",
      },
      {
        type: "p",
        text: "评论区里有一条被顶到最上面：原来他还在唱。这句话里没有惋惜，只有一种迟到了十五年的确认。",
      },
    ],
  },
  {
    id: "zongyi-2013-live-accident",
    title: "一段没被剪掉的三分钟，成了综艺史上最长的名场面",
    excerpt:
      "直播出了事故，导演说掐掉，导播没舍得。那三分钟后来成了这档节目所有集数里，被回放次数最多的一段。",
    category: "zongyi",
    categoryName: "综艺名场面",
    cover:
      "https://readdy.ai/api/search-image?query=retro%20television%20set%20glowing%20warm%20amber%20in%20a%20dark%20vintage%20room%2C%20CRT%20screen%20with%20static%20light%2C%20broadcast%20nostalgia%20aesthetic%2C%20dust%20and%20deep%20shadow%2C%20artistic%20cinematic%20still%2C%20no%20people%2C%20muted%20red%20and%20gold%20tones&width=800&height=600&seq=arch-zongyi-2013&orientation=landscape",
    date: "2026-08-12",
    year: "2013",
    readTime: 7,
    tags: ["综艺考古", "名场面", "旧料"],
    author: "档案室 · 阿野",
    content: [
      {
        type: "p",
        text: "直播综艺最怕的就是意外。可有些意外，恰恰是剧本写不出来的东西。2013 年那一期，台上嘉宾的一句话让全场安静了整整三分钟，没有配乐，没有笑声，只有镜头慢慢推近。",
      },
      {
        type: "h2",
        text: "一、导演喊了掐掉",
      },
      {
        type: "p",
        text: "事后有工作人员回忆，现场导播间气氛紧张到极点。按照流程，这种失控的片段应该立刻切广告。但导播在最后两秒改了主意，让它完整播了出去。",
      },
      {
        type: "quote",
        text: "他说，观众有权看见真实的那三分钟，哪怕它不好看。",
      },
      {
        type: "h2",
        text: "二、观众记住了什么",
      },
      {
        type: "p",
        text: "第二天，那三分钟的讨论冲上了当时的论坛首页。很多人不是在看热闹，而是在那三分钟里，第一次看到一档娱乐节目愿意停下来，不急着找补。",
      },
      {
        type: "list",
        items: [
          "当年话题讨论量：超过两百万条。",
          "节目组收到观众来信：四千多封，一半是手写的。",
          "后来该节目十周年特辑，把这段重新播放了一次。",
        ],
      },
      {
        type: "h2",
        text: "三、为什么它还能被翻出来",
      },
      {
        type: "p",
        text: "现在的综艺节奏越来越快，三十秒一个包袱，两分钟一个反转。正因为快，那三分钟的慢才显得像是另一个时代留下的东西。翻出来的不是意外，是一种已经很少见的耐心。",
      },
    ],
  },
  {
    id: "yinyue-2005-demo",
    title: "一盘没寄出去的 demo，在抽屉里躺了二十年",
    excerpt:
      "卡带外壳上只写了一个日期和三个字。二十年后它被转到数字格式，第一句旋律响起来，评论区安静了很久。",
    category: "yinyue",
    categoryName: "乐坛回响",
    cover:
      "https://readdy.ai/api/search-image?query=cassette%20tape%20and%20vintage%20headphones%20resting%20on%20aged%20paper%20with%20handwritten%20notes%2C%20warm%20golden%20window%20light%2C%20nostalgic%20still%20life%2C%20shallow%20depth%20of%20field%2C%20artistic%20editorial%20photography%2C%20sepia%20and%20amber%20tones%2C%20no%20people&width=800&height=600&seq=arch-yinyue-2005&orientation=landscape",
    date: "2026-08-05",
    year: "2005",
    readTime: 6,
    featured: true,
    tags: ["乐坛旧闻", "demo", "旧料翻出"],
    author: "档案室 · 小满",
    content: [
      {
        type: "p",
        text: "整理旧物的时候翻出一盘卡带，外壳右下角用圆珠笔写着「2005.4」和三个字：不寄了。这盘带子从来没有到过任何唱片公司手里。",
      },
      {
        type: "h2",
        text: "一、那三个字是什么意思",
      },
      {
        type: "p",
        text: "后来联系上当年的录音者才明白，他原本准备把 demo 寄给一家唱片公司，信封都写好了，地址也抄了两遍。最后出门前又把它放回了抽屉。理由说出来很简单：觉得还不够好。",
      },
      {
        type: "quote",
        text: "很多人一辈子只差一次「寄出去」。",
      },
      {
        type: "h2",
        text: "二、带子里到底录了什么",
      },
      {
        type: "p",
        text: "三首歌，两把木吉他，一间出租屋的混响。第一首的前奏有明显的底噪，是因为录的时候隔壁在装修。可正是那点底噪，让它听起来不像作品，像某个下午真实存在过。",
      },
      {
        type: "h2",
        text: "三、为什么值得翻出来",
      },
      {
        type: "p",
        text: "有些旧料的价值不在八卦，而在于它记录了一个人犹豫的样子。那盘带子后来被转成数字文件，第一句旋律响起来的时候，评论区没有一条在开玩笑。",
      },
    ],
  },
  {
    id: "wangluo-2009-forum-war",
    title: "2009 年那场论坛大战，现在的年轻人已经看不懂了",
    excerpt:
      "没有短视频，没有热搜，一场持续四十天的論战靠一页一页刷新。今天的梗，很多都是那时候留下的。",
    category: "wangluo",
    categoryName: "网络初代",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20desktop%20computer%20monitor%20glowing%20soft%20green%20in%20a%20dusty%20study%20room%2C%20early%20internet%20nostalgia%2C%20keyboard%20and%20old%20mouse%2C%20warm%20sepia%20tones%2C%20artistic%20cinematic%20still%2C%20no%20people%2C%20film%20grain&width=800&height=600&seq=arch-wangluo-2009&orientation=landscape",
    date: "2026-07-29",
    year: "2009",
    readTime: 9,
    tags: ["网络考古", "论坛时代", "初代梗"],
    author: "档案室 · 老周",
    content: [
      {
        type: "p",
        text: "那是一个还没有热搜榜的年份。一个话题要火起来，靠的是论坛首页的置顶和无数人手动顶帖。2009 年那场持续了四十天的论战，就是在那样的环境里长出来的。",
      },
      {
        type: "h2",
        text: "一、它是怎么开始的",
      },
      {
        type: "p",
        text: "起因现在看很小：一篇帖子里的一个用词。但那个年代的人对文字格外较真，一个词能引出上千楼的回复。第一个晚上，帖子就翻了七十多页。",
      },
      {
        type: "list",
        items: [
          "第一夜：七十页，主要争论一个说法该不该用。",
          "第七天：有人整理出长文，把争论拉到了更大的层面。",
          "第二十天：话题从论坛扩散到了博客，出现了大量的转载。",
          "第四十天：楼主发了一句话，然后注销了 ID。",
        ],
      },
      {
        type: "h2",
        text: "二、留下了什么",
      },
      {
        type: "p",
        text: "很多今天还在用的说法，最早都出自那几页回复。只是现在没人知道出处了，它们变成了表情、变成了口头禅，像河流下游的水，早就不记得自己从哪座山流下来的。",
      },
      {
        type: "quote",
        text: "考古的意义不是还原真相，而是发现我们今天说的话，很多都有人在十七年前说过。",
      },
      {
        type: "h2",
        text: "三、为什么现在的年轻人看不懂",
      },
      {
        type: "p",
        text: "因为那场论战没有配图、没有视频、没有表情包。它的全部弹药就是文字本身。习惯了三十秒获取信息的人，很难想象有人愿意花四十天，只为把一个观点说清楚。",
      },
    ],
  },
  {
    id: "yingshi-2007-forgotten-script",
    title: "被压了七年的剧本，开播那天没人看好",
    excerpt:
      "投资方换了三拨，演员走了一半。谁都没想到，这部「没人要」的剧后来成了那一年的黑马。",
    category: "yingshi",
    categoryName: "影视旧账",
    cover:
      "https://readdy.ai/api/search-image?query=old%20film%20script%20pages%20and%20a%20wooden%20clapperboard%20on%20a%20rustic%20desk%2C%20warm%20sepia%20desk%20lamp%20light%2C%20dust%20motes%2C%20artistic%20editorial%20still%20life%2C%20aged%20paper%20texture%2C%20no%20people%2C%20muted%20red%20and%20amber%20tones&width=800&height=600&seq=arch-yingshi-2007&orientation=landscape",
    date: "2026-07-22",
    year: "2007",
    readTime: 8,
    tags: ["影视旧账", "剧本", "旧料翻出"],
    author: "档案室 · 阿野",
    content: [
      {
        type: "p",
        text: "在影视行业，一部剧的命运有时候和它的质量无关。2007 年写好的这个剧本，先在抽屉里躺了三年，又被两个投资方先后放弃，等到真正开拍，已经换了三拨人。",
      },
      {
        type: "h2",
        text: "一、为什么被压着",
      },
      {
        type: "p",
        text: "理由当年听起来都很合理：题材不讨巧、没有流量演员、市场不认。可七年后再看，正是这些「不讨巧」的地方，让它在同类作品里显得格外扎实。",
      },
      {
        type: "quote",
        text: "制片人后来回忆：我们不是赌它会红，我们只是舍不得让它烂在柜子里。",
      },
      {
        type: "h2",
        text: "二、开播那天的数据",
      },
      {
        type: "list",
        items: [
          "首播收视：同时段第七，几乎没人讨论。",
          "第二周：口碑开始发酵，讨论量翻了四倍。",
          "收官：拿下当年同时段收视冠军。",
          "五年后：被列为「最被低估的电视剧」之一。",
        ],
      },
      {
        type: "h2",
        text: "三、旧账为什么值得翻",
      },
      {
        type: "p",
        text: "每一部被压过的作品背后，都站着几个不肯放弃的人。翻这些旧账，不是为了证明当年谁看走了眼，而是想提醒：判断一部作品的好坏，市场反应只是其中一种标准。",
      },
    ],
  },
  {
    id: "xuanxiu-2006-quit",
    title: "他在决赛前一夜退赛，理由至今只说过一次",
    excerpt:
      "所有人都以为他会夺冠。第二天他出现在后台，行李已经收拾好，只说了一句谢谢，转身就走。",
    category: "xuanxiu",
    categoryName: "选秀记忆",
    cover:
      "https://readdy.ai/api/search-image?query=empty%20retro%20auditorium%20seats%20lit%20by%20warm%20stage%20light%2C%20rows%20of%20red%20velvet%20chairs%20in%20shadow%2C%20film%20grain%2C%20cinematic%20wide%20shot%2C%20nostalgic%20mood%2C%20deep%20burgundy%20and%20gold%20tones%2C%20no%20people&width=800&height=600&seq=arch-xuanxiu-2006&orientation=landscape",
    date: "2026-07-15",
    year: "2006",
    readTime: 7,
    tags: ["选秀考古", "退赛", "旧料"],
    author: "档案室 · 小满",
    content: [
      {
        type: "p",
        text: "那届选秀的冠军之夜，名单上少了一个所有人都在等的人。他在决赛前一天晚上递交了退赛申请，工作人员反复确认了三次，他只是点头。",
      },
      {
        type: "h2",
        text: "一、那句话是什么",
      },
      {
        type: "p",
        text: "多年以后，他在一次很小的采访里第一次说出原因：他发现自己越来越在意名次，而不是音乐本身。他不想变成那样的人，所以在还来得及的时候先走了。",
      },
      {
        type: "quote",
        text: "他说：我怕的不是输，是赢着赢着，忘了自己为什么站在台上。",
      },
      {
        type: "h2",
        text: "二、之后发生了什么",
      },
      {
        type: "p",
        text: "那年的冠军后来过得不错，他也过得不错，只是再也没有参加过任何比赛。有人说他可惜，也有人说他清醒。两种说法都对，因为人生本来就不是只有一条赛道。",
      },
      {
        type: "h2",
        text: "三、这一段为什么总被翻出来",
      },
      {
        type: "p",
        text: "因为在一个所有人都在往前冲的赛场上，主动停下来需要更大的勇气。这段旧料被翻出来的时候，总是出现在大家很累的那几天。",
      },
    ],
  },
  {
    id: "wangluo-2010-blog",
    title: "博客时代的最后一位顶流，关站那天没人送行",
    excerpt:
      "他的博客有三百万人订阅。关站公告只有一句话，四十六个字。三个月后，博客这个形式也慢慢没人写了。",
    category: "wangluo",
    categoryName: "网络初代",
    cover:
      "https://readdy.ai/api/search-image?query=stack%20of%20old%20letters%20and%20a%20closed%20laptop%20on%20a%20desk%20lit%20by%20a%20warm%20desk%20lamp%2C%20dusty%20quiet%20room%2C%20nostalgic%20editorial%20photography%2C%20sepia%20and%20deep%20red%20accents%2C%20artistic%20mood%2C%20no%20people&width=800&height=600&seq=arch-wangluo-2010&orientation=landscape",
    date: "2026-07-08",
    year: "2010",
    readTime: 6,
    tags: ["网络考古", "博客时代", "旧料翻出"],
    author: "档案室 · 老周",
    content: [
      {
        type: "p",
        text: "2010 年前后，衡量一个人有没有影响力，看的不是粉丝数，是订阅数。他的博客有三百万人订阅，随便一篇文章的评论区都能刷出上千条。",
      },
      {
        type: "h2",
        text: "一、关站公告",
      },
      {
        type: "p",
        text: "公告很短，四十六个字，没有解释，也没有告别。发出来之后评论区很快就满了，但他没有再回复过任何一条。",
      },
      {
        type: "quote",
        text: "写博客的人都知道，停更从来不是一瞬间的决定，是攒了很久的疲惫。",
      },
      {
        type: "h2",
        text: "二、一个时代的退场",
      },
      {
        type: "p",
        text: "他关站之后不到一年，身边写博客的人一个接一个地停下。取而代之的是更短、更快、更碎的表达。那些长篇的东西，慢慢变成了只有少数人还在做的事。",
      },
      {
        type: "list",
        items: [
          "订阅人数：约三百二十万。",
          "最高单篇评论：逾一万两千条。",
          "关站公告字数：四十六个字。",
          "公告后的回复：零条。",
        ],
      },
    ],
  },
  {
    id: "zongyi-2016-edit",
    title: "被剪掉的那期节目，后来流出完整版",
    excerpt:
      "播出的是四十分钟，原始素材是三个小时。那多出来的两小时四十分里，藏着这一季最真实的部分。",
    category: "zongyi",
    categoryName: "综艺名场面",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20video%20editing%20tape%20deck%20and%20a%20small%20monitor%20in%20a%20warm%20lit%20retro%20studio%2C%20reels%20and%20cables%2C%20warm%20amber%20lighting%2C%20film%20grain%2C%20artistic%20cinematic%20still%2C%20no%20people%2C%20muted%20gold%20tones&width=800&height=600&seq=arch-zongyi-2016&orientation=landscape",
    date: "2026-06-30",
    year: "2016",
    readTime: 8,
    tags: ["综艺考古", "剪辑", "旧料翻出"],
    author: "档案室 · 阿野",
    content: [
      {
        type: "p",
        text: "一档综艺的播出时长是四十分钟，可录制素材往往有三个小时。剪辑室决定了观众看见什么，也决定了什么被永远留在硬盘里。",
      },
      {
        type: "h2",
        text: "一、多出来的那部分",
      },
      {
        type: "p",
        text: "完整素材在多年后被整理出来。里面有一段长达十五分钟的沉默，几位嘉宾只是坐着，谁都没说话。剪辑师当年删掉它，是因为电视不允许这么长的留白。",
      },
      {
        type: "quote",
        text: "可恰恰是那段沉默，让人看见了几个人真实的相处方式。",
      },
      {
        type: "h2",
        text: "二、剪辑是一门外语",
      },
      {
        type: "p",
        text: "综艺剪辑本质上是翻译：把三个小时的现场，翻译成四十分钟可以让观众看懂的语言。问题是，任何翻译都会流失一些东西。那段沉默就是被流失掉的部分。",
      },
      {
        type: "h2",
        text: "三、完整版为什么值得看",
      },
      {
        type: "p",
        text: "因为它改变了你对这档节目的印象。播出时的节奏明快、笑点密集；完整版里，嘉宾会累、会走神、会突然认真。两种版本合起来，才是那期节目真正的样子。",
      },
    ],
  },
  {
    id: "yingshi-1998-extra",
    title: "龙套三年，他靠一句台词被记住",
    excerpt:
      "整部剧他的镜头加起来不到两分钟，台词只有一句。二十多年过去了，那句台词还在被引用。",
    category: "yingshi",
    categoryName: "影视旧账",
    cover:
      "https://readdy.ai/api/search-image?query=vintage%20film%20reel%20and%20sprockets%20with%20a%20strip%20of%20film%20frames%20unspooled%20on%20aged%20paper%2C%20warm%20sepia%20light%2C%20nostalgic%20still%20life%2C%20grain%20and%20dust%2C%20artistic%20editorial%20photography%2C%20no%20people&width=800&height=600&seq=arch-yingshi-1998&orientation=landscape",
    date: "2026-06-22",
    year: "1998",
    readTime: 6,
    tags: ["影视旧账", "龙套", "名台词"],
    author: "档案室 · 小满",
    content: [
      {
        type: "p",
        text: "翻开那部老剧的演员表，他的名字排在很后面，后面还跟着一个括号，里面写着「客串」。他在整部剧里的戏份加起来不到两分钟。",
      },
      {
        type: "h2",
        text: "一、只有一句台词",
      },
      {
        type: "p",
        text: "他演一个路过的邻居，全剧只有一句台词。后来有观众把那一集逐帧截出来，发现他站在那里等电梯的姿势，比主角还要准确。",
      },
      {
        type: "quote",
        text: "好演员就是这样，哪怕只给一句台词，他也会把这个人物的前半生准备好。",
      },
      {
        type: "h2",
        text: "二、三年龙套换来的一分钟",
      },
      {
        type: "p",
        text: "在此之前，他跑了三年龙套，大多数时候连脸都拍不清。有人问他为什么不放弃，他说因为总有一句台词会轮到自己的。",
      },
      {
        type: "h2",
        text: "三、为什么今天还要翻出来",
      },
      {
        type: "p",
        text: "因为它重新定义了「被记住」。不是所有被记住的人都站在聚光灯下，有些人只是把一句台词，说得比谁都认真。",
      },
    ],
  },
  {
    id: "yinyue-1999-band",
    title: "解散二十年的乐队，去年在小酒馆重聚",
    excerpt:
      "没有宣传，没有直播，门票只在门口卖。来了七十多个人，半数以上是当年买过卡带的。",
    category: "yinyue",
    categoryName: "乐坛回响",
    cover:
      "https://readdy.ai/api/search-image?query=electric%20guitar%20leaning%20against%20a%20stool%20in%20a%20warm%20lit%20vintage%20rehearsal%20room%2C%20dust%20in%20light%20beams%2C%20amp%20and%20cables%2C%20nostalgic%20mood%2C%20artistic%20cinematic%20still%2C%20deep%20red%20and%20amber%20tones%2C%20no%20people&width=800&height=600&seq=arch-yinyue-1999&orientation=landscape",
    date: "2026-06-14",
    year: "1999",
    readTime: 7,
    tags: ["乐坛旧闻", "乐队", "重聚"],
    author: "档案室 · 老周",
    content: [
      {
        type: "p",
        text: "他们 1999 年组建，2004 年解散。解散的原因很常见：没钱、没演出、没耐心。四个人各奔东西，最远的一个去了另一个国家。",
      },
      {
        type: "h2",
        text: "一、二十年后的那场演出",
      },
      {
        type: "p",
        text: "重聚没有任何商业推动。是一个老乐迷在群里随口问了一句「还聚得起来吗」，四个人半年后真的凑齐了。地点是一间只能站下八十人的小酒馆，门票手写，门口收现金。",
      },
      {
        type: "list",
        items: [
          "到场人数：七十余人。",
          "曲目：当年的九首，加一首从未发表的新歌。",
          "设备：借的。",
          "宣传：零。",
        ],
      },
      {
        type: "quote",
        text: "主唱说：我们不是为了复出，只是想在还弹得动的时候，把最后那首歌唱完。",
      },
      {
        type: "h2",
        text: "二、为什么这样的旧料打动人心",
      },
      {
        type: "p",
        text: "因为大多数解散的乐队都不会重聚。他们不会发复出声明，不会上综艺怀旧，只会在某个晚上，突然出现在一间很小的地方，把二十年前没做完的事做完。",
      },
    ],
  },
];